/* unplugin-vue-components disabled */import script from "./Quality.vue?vue&type=script&setup=true&lang=js"
export * from "./Quality.vue?vue&type=script&setup=true&lang=js"

import "./Quality.vue?vue&type=style&index=0&id=46a3cafe&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a3cafe"]])

export default __exports__